
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/homepage",
      function () {
        return require("private-next-pages/employer/homepage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/homepage"])
      });
    }
  